module.exports = __webpack_public_path__ + "static/media/turkish_flag.406e4d85.jpg";